<script>
import { stringToColor } from '~/utils/color_utils';

// Warning: This is a non-reactive component intended for usage in report tables.
// If you need the component to change when props are updated use
// AppAvatarInitial instead.
export default {
  name: 'ReportTableAvatarInitial',
  functional: true,
  props: {
    text: {
      type: String,
      required: true,
    },
    classModifier: {
      type: String,
      default: '',
    },
  },
  render(createElement, context) {
    const text = context.props.text;
    const displayText = text[0].toUpperCase();
    const backgroundColor = stringToColor(text);
    const attrs = {
      class: `avatar_initial ${context.props.classModifier}`,
      style: {
        backgroundColor,
      },
    };

    return createElement('div', attrs, [displayText]);
  },
};
</script>
